import { isValid, parse } from "date-fns";

// PCRS returns the registration date as dd/MM/yyyy (see pcrsDetails) but may
// also send an ISO date — accept both.
const REGISTRATION_DATE_FORMATS = ["dd/MM/yyyy", "yyyy-MM-dd"];

const parseRegistrationDate = (value) => {
  if (!value) return null;

  const text = String(value)
    .replace(/Z$/i, "")
    .trim();

  for (const dateFormat of REGISTRATION_DATE_FORMATS) {
    const parsed = parse(text, dateFormat, new Date());
    if (isValid(parsed)) return parsed;
  }

  return null;
};

// True when the given PCRS registration date falls in the current calendar
// month. A registration in the ongoing month isn't verifiable by PCRS until the
// 1st of next month (fresh registration or mid-month panel transfer), so a
// review dated this month may not be paid / may be rejected until then.
export const isDateInCurrentMonth = (value, today = new Date()) => {
  const parsed = parseRegistrationDate(value);
  if (!parsed) return false;

  return (
    parsed.getFullYear() === today.getFullYear() &&
    parsed.getMonth() === today.getMonth()
  );
};
